<div #filterOutput class="filters">
  <button *ngFor="let flt of selectedFilters"
          kendoButton
          [class]="flt.cssclass"
          (click)="onButtonClick($event, flt.id!)"
          [svgIcon]="xicon"
          [title]="flt.controlName + ': ' + flt.text">
    {{ flt.text }}
  </button>
</div>
